const getWikiChildren = (namePrefix = '', meta = {}) => {
    return [
        {
            path: '',
            name: namePrefix + 'MainWikiPage',
            props: true,
            component: () => import(/* webpackChunkName: "wikiSections" */ './WikiMainPageMenu.vue'),
            meta
        },
        {
            path: ':sectionId(\\d+)/',
            name: namePrefix + 'WikiSubsectionPage',
            props: true,
            component: () => import(/* webpackChunkName: "wikiSections" */ './WikiSectionPage.vue'),
            meta
        },
        {
            path: 'detail/:sectionId(\\d+)/:slideId(\\d+)?/',
            name: namePrefix + 'WikiSectionPageDetail',
            props: true,
            component: () => import(/* webpackChunkName: "wikiSections" */ './WikiDetailPage.vue'),
            meta
        },
    ];
};

const getMainWikiPageName = (namePrefix = '') => {
    return namePrefix + 'MainWikiPage';
};
const getSubsectionWikiPageName = (namePrefix = '') => {
    return namePrefix + 'WikiSubsectionPage';
};
const getSubsectionDetailWikiPageName = (namePrefix = '') => {
    return namePrefix + 'WikiSectionPageDetail';
};

export {getWikiChildren, getMainWikiPageName, getSubsectionDetailWikiPageName, getSubsectionWikiPageName};
